import {createElement, Component, PropTypes} from 'rlink-react';
import telemetry from 'rlink-telemetry';
import themeable from 'rlink-theme/themeable';
import {ContentImg} from 'rlink-repos/content-components';
import placeholder from './assets/placeholder.png';
export class PromotionTilePanel extends Component {
  render () {
    return (
      <div className={this.props.css[`${this.props.layoutType}-container`]}>
        {(() => {
          switch (this.props.layoutType) {
            case 'tiling':
              return this.renderTilingLayout(this.props.tileAmount);
            case 'horizontal':
              return this.renderHorizontalLayout();
            default:
              return [];
          }
        })()}
      </div>
    );
  }

  formatDate(dateRaw) {
    let date = new Date(dateRaw);

    return `${this.props.monthNames[date.getMonth()]} ${(date.getDate() < 10) ? `0${date.getDate()}` : date.getDate()} ${date.getFullYear()}`;
  }


  renderTiles(layoutType, maxTiles, className, classNameSubsequent = '') {
    let tiles = [];
    let checkedPromotionTiles = false;
    let index = 0;
    while (tiles.length < maxTiles) {
      if (index < this.props.content.size) {
        let promotionTile = this.props.content.get(index);
        if (promotionTile.get('layoutType') == layoutType && this.currentlyAvailable(promotionTile) && this.locationAllowed(promotionTile)) {
          tiles.push(<PromoTile
            key={index}
            css={this.props.css}
            onClick={this.props.onTileClick}
            tileAction={promotionTile.get('tileAction', '')}
            tileParams={promotionTile.get('tileParams', [])}
            title={promotionTile.get('title', "")}
            subtitle={(promotionTile.get('showSubtitle', false) && promotionTile.get('visibleFrom', ''))
              ? this.formatDate(promotionTile.get('visibleFrom', ''))
              : ''}
            className={(tiles.length > 0 && classNameSubsequent)
                          ? classNameSubsequent
                          : className}
            tileHref={promotionTile.get('tileHref', '')}
            backgroundPath={promotionTile.get('backgroundPath')}
            telemetryIdentifier={promotionTile.get('telemetryIdentifier')}
            showPromoButton={this.props.showPromoButton}
            promoButtonText={this.props.promoButtonText} />);
        }

        index += 1;
      } else {
        tiles.push(
          <div className={this.props.css[(tiles.length > 0 && classNameSubsequent) ? classNameSubsequent : className]}>
            <img src={placeholder} />
          </div>);
      }
    }

    return tiles;
  }

  renderTilingLayout (tileAmount) {
    let tiles = this.renderTiles('tiling', tileAmount, 'banner-large', 'banner-small');
    let smallTiles = [];
    if (tileAmount > 1) {
      for (let i = 1; i < tiles.length; i++) {
        smallTiles.push(tiles[i]);
      }
    }

    return ([tiles[0]].concat((smallTiles.length > 0) ? [<div className={this.props.css['banner-small-container']}>{smallTiles}</div>] : []));
  }

  renderHorizontalLayout () {
    return this.renderTiles('horizontal', 2, 'banner-horizontal');
  }

  currentlyAvailable (promotionTile) {
    let currentDate = new Date();
    let visibleFrom = promotionTile.get('visibleFrom');
    if (typeof (visibleFrom) !== 'undefined') {
      let startDate = new Date(visibleFrom);
      if (currentDate < startDate) {
        return false;
      }
    }

    let visibleUntil = promotionTile.get('visibleUntil');
    if (typeof (visibleUntil) !== 'undefined') {
      let endDate = new Date(visibleUntil);
      if (currentDate > endDate) {
        return false;
      }
    }

    return true;
  }

  locationAllowed (promotionTile) {
    if (this.props.displayLocation === '' || promotionTile.get('displayLocations').length === 0) {
      return true;
    }

    return (promotionTile.get('displayLocations').includes(this.props.displayLocation));
  }
};

PromotionTilePanel.propTypes = {
  className: PropTypes.string,
  tileAmount: PropTypes.number,
  css: PropTypes.object,
  displayLocation: PropTypes.string,
  onTileClick: PropTypes.func,
}

PromotionTilePanel.defaultProps = {
  className: '',
  tileAmount: 3,
  css: {},
  displayLocation: '',
  monthNames: [
    "Jan", "Feb", "Mar",
    "Apr", "May", "Jun",
    "Jul", "Aug", "Sep",
    "Oct", "Nov", "Dec"
  ]
}

themeable(PromotionTilePanel, {
  classes: [],
});

export class PromoTile extends Component {
  componentDidMount () {
    telemetry.trackView(`${location.pathname}#${this.props.telemetryIdentifier}`);
  }
  onClick (ev) {
    this.trackNav();
    if (this.props.onClick) {
      this.props.onClick({
        ev,
        tileAction: this.props.tileAction,
        tileParams: this.props.tileParams.toJS(),
      });
      ev.preventDefault();
    }
  }
  trackNav () {
    telemetry.trackNav(this.props.tileHref);
  }
  render () {
    return (
      <div className={this.props.css.PromoTileBase + ' ' + this.props.css[this.props.className]}>
        {(() => {
          if (this.tileHref !== '') {
            return (
              <a
                onClick={ev => this.onClick(ev)}
                href={`${this.props.tileHref}`}>
                {this.renderInnerTile()}
              </a>);
          } else {
            return this.renderInnerTile();
          }
        })()}
        {(this.props.showPromoButton)
          && <a className={this.props.css.PromoButton} href={`${this.props.tileHref}`}>
            {this.props.promoButtonText}
          </a>}
      </div>
    );
  }

  renderInnerTile() {
    let image = <ContentImg src={this.props.backgroundPath}/>;
    if (this.props.title) {
      return <span>
        {image}
        <div className={this.props.css.Text}>
          {(this.props.subtitle) && <span className={this.props.css.Subtitle}>{this.props.subtitle}</span>}
          <span className={this.props.css.Title}>{this.props.title}</span>
        </div>
      </span>
    }

    return image;
  }
}

PromoTile.propTypes = {
  className: PropTypes.string,
  tileHref: PropTypes.string,
  backgroundPath: PropTypes.string,
  telemetryIdentifier: PropTypes.string.isRequired,
  onClick: PropTypes.func,

};

PromoTile.defaultProps = {
  className: '',
  tileHref: '',
  backgroundPath: '',
};



// WEBPACK FOOTER //
// ./lib/rlink-promotiles/component.jsx